import { render } from "./CreateAppointmentPassMultipleForm.vue?vue&type=template&id=082d6140"
import script from "./CreateAppointmentPassMultipleForm.vue?vue&type=script&lang=js"
export * from "./CreateAppointmentPassMultipleForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__